import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicSelect from '../BasicSelect';
import CheckboxMultiSelect from '../CheckboxMultiSelect';

const RatedByListFilter = props => {
  const {
    ratedBySelectedList,
    ratedByList,
    ratedOnList,
    ratedByOnChangeHandler,
    ratedOnOnChangeHandler,
  } = props;

  const [ratedOn, setRatedOn] = useState(null);

  const onRatedOnChange = value => {
    setRatedOn(value);
    if (ratedOnOnChangeHandler) {
      ratedOnOnChangeHandler(value);
    }
  };

  let showRatedByOptions = false;

  const toggleRatedByOptions = showOptions => {
    showRatedByOptions = showOptions;
  };

  return (
    <div className="rated-by-list-filter">
      <div className="rated-by-list-filter__control">
        <CheckboxMultiSelect
          name="ratedByList"
          items={ratedByList}
          selectedItems={ratedBySelectedList}
          placeholder="Rated By"
          groups={false}
          onChange={ratedByOnChangeHandler}
          disableOnClickOutside={showRatedByOptions === true}
          controlFuncOptions={toggleRatedByOptions}
        />
      </div>
      <div className="rated-by-list-filter__control">
        <BasicSelect
          isSearchable={false}
          name="ratedOn"
          value={ratedOn}
          isValid={true}
          placeholder="Select From List"
          options={ratedOnList}
          controlFunc={onRatedOnChange}
        />
      </div>
    </div>
  );
};

RatedByListFilter.propTypes = {
  ratedByList: PropTypes.array.isRequired,
  ratedOnList: PropTypes.array.isRequired,
  ratedByOnChangeHandler: PropTypes.func,
  ratedOnOnChangeHandler: PropTypes.func,
};
export default RatedByListFilter;
